/**
 * Effective role list for clients: prefers **`roles`** from `/me` when non-empty; otherwise **`[role]`** (legacy).
 */
export function effectiveUserRoles(user) {
    if (user.roles != null && user.roles.length > 0) {
        return [...new Set(user.roles)];
    }
    return [user.role];
}
export function userHasPlatformAdminRole(user) {
    return effectiveUserRoles(user).includes("platform_admin");
}
/** When multiple roles exist, staff roles sort before `customer` so legacy `role` matches dispensary/transporter UIs. */
const LEGACY_ROLE_PRIORITY = [
    "platform_admin",
    "dispensary_dispatcher",
    "dispensary_budtender",
    "transporter_dispatcher",
    "driver",
    "customer",
];
/**
 * Single-role summary for APIs/clients not yet using `roles[]`.
 * Prefer checking `roles.includes(...)` for authorization.
 */
export function legacyPrimaryRole(roles) {
    for (const r of LEGACY_ROLE_PRIORITY) {
        if (roles.includes(r))
            return r;
    }
    return roles[0];
}
export function userHasRole(user, role) {
    return user.roles.includes(role);
}
export function userHasAnyRole(user, roles) {
    return roles.some((r) => user.roles.includes(r));
}
//# sourceMappingURL=auth-roles.js.map